const HonoraireListePartenaireMet = ({}) => {

    return (
        <>
            
        </>
    )
}

export default HonoraireListePartenaireMet;